import { RouteConfig } from "vue-router";

export const REmployeesBrowse: RouteConfig = {
  name: "EmployeesBrowse",
  path: "",
  component: () =>
    import(
      /* webpackChunkName: "employees-browse" */
      "./VEmployeesBrowse.vue"
    ),
  meta: {
    title: "Employees",
  },
};
